/* EU legal guarantee notice (Implementing Regulation (EU) 2025/1960).
   Opens the harmonised notice in the <dialog> rendered once by layout/theme.liquid
   (snippets/eu-legal-guarantee.liquid, mode 'dialog').
   - One delegated click listener in the capture phase: triggers inside the cart drawer and
     product info are re-rendered from Liquid, and the configurator drawer panel stops click
     propagation in the bubble phase.
   - The artwork only loads on first hover/focus/click of a trigger.
   - Escape closes the notice only: it is kept away from the cart drawer (closes on keyup)
     and the custom header (closes menus on keydown).
   - Without JS (or without <dialog> support) the trigger is a plain link to the artwork. */
(function () {
  'use strict';

  var OPEN = '[data-eu-lg-open]';
  var swallowEscapeUp = false;
  var pressedOnBackdrop = false;
  var releasedOnBackdrop = false;
  var swallowClicksUntil = 0;

  function getDialog() {
    return document.querySelector('[data-eu-lg-dialog]');
  }

  function loadNotice() {
    var dialog = getDialog();
    var img = dialog && dialog.querySelector('img[data-src]');
    if (img && !img.getAttribute('src')) img.setAttribute('src', img.getAttribute('data-src'));
  }

  function openNotice() {
    var dialog = getDialog();
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    loadNotice();
    if (!dialog.open) {
      dialog.showModal();
      var scroller = dialog.querySelector('.eu-lg-dialog__scroll');
      if (scroller) {
        scroller.scrollTop = 0;
        scroller.scrollLeft = 0;
      }
    }
    return true;
  }

  function isEscape(event) {
    return event.key === 'Escape' || event.key === 'Esc';
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      // Rest of a double-click whose first click closed the notice from the backdrop: keep it
      // from reaching whatever is underneath (cart drawer overlay, configurator drawer, links).
      if (event.detail > 1 && event.timeStamp < swallowClicksUntil) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      var trigger = target.closest(OPEN);
      if (trigger) {
        // Let modified clicks (new tab / window) follow the link to the artwork.
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (openNotice()) event.preventDefault();
        return;
      }

      var dialog = getDialog();
      if (!dialog || !dialog.open) return;
      if (target.closest('[data-eu-lg-close]')) {
        dialog.close();
        return;
      }
      // Backdrop (the dialog box has no padding, so only the backdrop targets the dialog itself).
      // Pressed and released there, single click: not a drag into or out of the notice, not the
      // second click of a double-click that opened it.
      if (target === dialog && pressedOnBackdrop && releasedOnBackdrop && event.detail <= 1) {
        dialog.close();
        swallowClicksUntil = event.timeStamp + 600;
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    function (event) {
      var dialog = getDialog();
      pressedOnBackdrop = !!dialog && dialog.open && event.target === dialog;
    },
    true
  );

  document.addEventListener(
    'pointerup',
    function (event) {
      var dialog = getDialog();
      releasedOnBackdrop = !!dialog && dialog.open && event.target === dialog;
    },
    true
  );

  // The rest of that double-click must not move focus or select text underneath either.
  ['mousedown', 'dblclick'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        if (event.detail > 1 && event.timeStamp < swallowClicksUntil) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );
  });

  ['pointerover', 'focusin'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        if (event.target && event.target.closest && event.target.closest(OPEN)) loadNotice();
      },
      { passive: true }
    );
  });

  window.addEventListener(
    'keydown',
    function (event) {
      if (!isEscape(event)) return;
      var dialog = getDialog();
      if (!dialog || !dialog.open) {
        // Auto-repeat of the Escape press that closed the notice: still ours.
        if (swallowEscapeUp && event.repeat) {
          event.stopPropagation();
          return;
        }
        swallowEscapeUp = false;
        return;
      }
      // Not preventDefault: the browser still closes the dialog.
      event.stopPropagation();
      swallowEscapeUp = true;
    },
    true
  );

  window.addEventListener(
    'keyup',
    function (event) {
      if (!swallowEscapeUp || !isEscape(event)) return;
      swallowEscapeUp = false;
      event.stopPropagation();
    },
    true
  );

  /* The cable configurator builds its "Added to cart" drawer in JS (assets/cable-configurator.js,
     not modified). Its Checkout button goes straight to /checkout, so add the trigger to its footer. */
  function addToConfiguratorDrawers() {
    var template = document.getElementById('EuLegalGuarantee-Trigger');
    if (!template || !template.content) return;
    var feet = document.querySelectorAll('.acfg__drawer-foot');
    for (var i = 0; i < feet.length; i++) {
      if (!feet[i].querySelector(OPEN)) feet[i].appendChild(template.content.cloneNode(true));
    }
  }

  // The engine builds its drawer on init and dispatches arachne:cart:added right after opening it.
  document.addEventListener('arachne:cart:added', addToConfiguratorDrawers);
  window.addEventListener('load', addToConfiguratorDrawers);
  addToConfiguratorDrawers();

  /* The configurator section renders the trigger after the whole configurator (the engine owns
     everything inside its mount). Once the engine has built its Add to cart block, copy the
     trigger there, under the buttons and the shipping line, and hide the original. Copied, not
     moved: "Start over" clears the mount and builds a new block, so the original stays in
     place for the next copy. If the block is missing, the original simply stays visible. */
  function moveIntoConfiguratorCta(root) {
    var holder = root.querySelector('.acfg__legal-guarantee');
    var row = holder && holder.querySelector('.eu-lg');
    if (!row) return false;
    var cta = root.querySelector('.acfg__cta-block');
    if (!cta) {
      holder.hidden = false;
      return false;
    }
    if (!cta.querySelector(OPEN)) {
      var copy = row.cloneNode(true);
      var after = cta.querySelector('.acfg__shipline') || cta.querySelector('.acfg__cta-trust');
      if (after && after.parentNode === cta) cta.insertBefore(copy, after.nextSibling);
      else cta.appendChild(copy);
    }
    holder.hidden = true;
    return true;
  }

  function watchConfigurators() {
    var roots = document.querySelectorAll('[data-acfg-root]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.__euLgWatched) return;
      root.__euLgWatched = true;
      moveIntoConfiguratorCta(root);
      if (typeof MutationObserver !== 'function') return;
      // The engine replaces the mount's only child on init and on every "Start over"
      // (reset -> _build): its direct children change exactly then, never on option changes.
      var mount = root.querySelector('[data-acfg-mount]') || root;
      new MutationObserver(function () {
        moveIntoConfiguratorCta(root);
      }).observe(mount, { childList: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchConfigurators);
  else watchConfigurators();
  // Theme editor: a re-rendered configurator section brings a new, unwatched root.
  document.addEventListener('shopify:section:load', watchConfigurators);
})();
